export var actionTypePrefix = '@@header';
export var reduxKey = '@@header';
//# sourceMappingURL=constants.js.map